import {
  Divider,
  DownloadAndInformationContainer,
  DownloadButton,
  DownloadContainer,
  DownloadHeading,
  DownloadIconAndTextContainer,
  DownloadSubheading,
  DownloadTextContainer,
  Message,
  MessageAndImageContainer,
  MessageContainer,
  PackageName,
  PaymentSuccessContainer,
  WhatsNext,
  HorizontalRule,
  InformationContainer,
  Information,
  InformationTextContainer,
  InformationHeading,
  InformationSubheading,
  DownloadAndInformationContainerCard,
  MainPageCTAInImage,
  MainPageCTAInInformation,
  QRCodeAndStoreButtonsContainer,
  StoreButtonsAndTextContainer,
  StoreText,
  StoreLink,
  MainPageCTALink,
  PaymentSuccessImageContainer,
  InformationImageContainer
} from "./payment-success.styles";
import Image from "next/legacy/image";
import Link from "next/link";
import PaymentSuccessImg from "public/assets/payment-success.svg";
import DownloadIcon from "public/assets/download-icon.svg";
import QrCodeImg from "public/assets/qr-code-download.svg";
import GooglePlayImg from "public/assets/google-play.svg";
import AppleStoreImg from "public/assets/apple-store.svg";
import { informationData } from "./payment-success.data";

const PaymentSuccess: React.FC = () => {
  return (
    <PaymentSuccessContainer>
      <MessageAndImageContainer>
        <PaymentSuccessImageContainer>
          <Image
            width="150"
            height="150"
            layout="responsive"
            sizes="(min-width: 768px) 150px, 250px"
            alt="payment-success"
            src={PaymentSuccessImg}
          />
        </PaymentSuccessImageContainer>
        <MessageContainer>
          <Message>Pembayaranmu udah diterima. Paket yang dibeli:</Message>
          <PackageName>✨ Selamat ✨</PackageName>

          <MainPageCTALink href="/">
            <MainPageCTAInImage>Kembali ke halaman utama</MainPageCTAInImage>
          </MainPageCTALink>
        </MessageContainer>
      </MessageAndImageContainer>
      <Divider />
      <DownloadAndInformationContainerCard>
        <DownloadAndInformationContainer>
          <DownloadContainer>
            <WhatsNext>Selanjutnya apa, nih?</WhatsNext>
          </DownloadContainer>
          <DownloadIconAndTextContainer>
            <InformationImageContainer>
              <Image
                src={DownloadIcon}
                alt="download-icon"
                layout="fill"
              ></Image>
            </InformationImageContainer>
            <DownloadTextContainer>
              <DownloadHeading>Download CoLearn, yuk!</DownloadHeading>
              <DownloadSubheading>
                Bisa foto soal, ikutan Kelas Live, dan cek perkembangan belajar
                di Aktivitasku.
              </DownloadSubheading>
            </DownloadTextContainer>
          </DownloadIconAndTextContainer>
          <Link href="https://colearn.app.link/KI0jhMUWUjb" passHref>
            <DownloadButton>Download Colearn</DownloadButton>
          </Link>

          <QRCodeAndStoreButtonsContainer>
            <Image
              src={QrCodeImg}
              alt="qr-code-img"
              height={160}
              width={160}
            ></Image>
            <StoreButtonsAndTextContainer>
              <StoreText>Tersedia juga di:</StoreText>
              <StoreLink
                target="_blank"
                href="https://play.google.com/store/apps/details?id=com.iq.colearn"
              >
                <Image
                  src={GooglePlayImg}
                  alt="google-play-img"
                  height={39}
                  width={136}
                />
              </StoreLink>
              <StoreLink
                target="_blank"
                href="https://apps.apple.com/in/app/colearn/id1498950339"
              >
                <Image
                  src={AppleStoreImg}
                  alt="apple-store-img"
                  height={39}
                  width={136}
                />
              </StoreLink>
            </StoreButtonsAndTextContainer>
          </QRCodeAndStoreButtonsContainer>
          <HorizontalRule />
        </DownloadAndInformationContainer>
        <InformationContainer>
          {informationData.map((information) => {
            return (
              <Information key={information.id}>
                <InformationImageContainer>
                  <Image
                    layout="fill"
                    src={information.imgSrc}
                    alt={information.alt}
                  />
                </InformationImageContainer>
                <InformationTextContainer>
                  <InformationHeading>{information.heading}</InformationHeading>
                  <InformationSubheading>
                    {information.subheading}
                  </InformationSubheading>
                </InformationTextContainer>
              </Information>
            );
          })}

          <MainPageCTALink href="/">
            <MainPageCTAInInformation>
              Kembali ke halaman utama
            </MainPageCTAInInformation>
          </MainPageCTALink>
        </InformationContainer>
      </DownloadAndInformationContainerCard>
    </PaymentSuccessContainer>
  );
};

export { PaymentSuccess };
